import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    List,
    Card,
    ListItemIcon
} from '@material-ui/core';
import { ReportsHomeCss as useStyles } from './ReportsCss';
import { gridLayer } from 'leaflet';
import { ListItem } from '@material-ui/core';
import { CardContent } from '@material-ui/core';
import { ProfitLossReportIconHome,TransactionReportsIconHome, PartyBalanceReportsIconHome, SupplierBalanceReportIconHome } from '../../../components/icons';
import TruckIncomeReport from '../../components/ReportSideBar/TruckIncomeReport';
import PartyIncomeReport from '../../components/ReportSideBar/PartyIncomeReport';
import AddEditTripSideBar from '../../components/Trip/AddEditTripSideBar';
import ProfitLossReport from '../../components/ReportSideBar/ProfitLossReport';
import ReportsDialog from '../../components/ReportsDialog/ReportsDialog';
import { trackDwebEvent } from "../../analytics";
import PartyBalanceReport from "./Party/PartyBalanceReport";
import SupplierBalanceReport from './Supplier/SupplierBalanceReport';
import TransactionReportDialog from '../../components/ReportsDialog/TransactionReportDialog';
const Reports = ({ }) => {

    const [reportOpen, setReportOpen] = useState(false);
    const [partyIncomeOpen, setPartyIncomeOpen] = useState(false);
    const [addTripSideBarOpen, setAddTripSideBarOpen] = useState(false);
    const [profitLossOpen, setProfitLossOpen] = useState(false);
    const [reportTitle, setReportTitle] = useState("");
    const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
    const [partyBalanceReportOpen, setPartyBalanceReportOpen] = useState(false);
    const [supplierBalanceReportOpen, setSupplierBalanceReportOpen] = useState(false);
    const [transactionReportOpen, setTransactionReportOpen] = useState(false);

    const classes = useStyles();

    useEffect(() => {
        trackDwebEvent("Dweb Reports page", {});
    }, []);

    const reportTypes = [
        {
            reportName: "profitLoss",
            icon: <ProfitLossReportIconHome className={classes.profitLossReportIcon} />,
            title: "Profit & Loss Report",
            textCss: "textV1"
        },
        {
            reportName: "truckIncome",
            icon: <img src={`${process.env.PUBLIC_URL}/assets/images/truck-income-report.png`} alt={"Truck Income"} className={classes.truckIncomeReportIcon} />,
            title: "Truck Revenue Report",
            textCss: "textV1"
        },
        {
            reportName: "partyIncome",
            icon: <img src={`${process.env.PUBLIC_URL}/assets/images/party-income-report.png`} alt={"Party Income"} className={classes.partyIncomeReportIcon} />,
            title: "Party Revenue Report",
            textCss: "textV2"
        },
        {
            reportName: "supplierBalance",
            icon: <SupplierBalanceReportIconHome className={classes.supplierBalanceReportIcon} />,
            title: "Supplier Balance Report",
            textCss: "textV3"
        },
        {
            reportName: "partyBalance",
            icon: <PartyBalanceReportsIconHome className={classes.partyBalanceReportIcon} />,
            title: "Party Balance Report",
            textCss: "textV3"
        },
        {
            reportName: "transactionReport",
            icon: <TransactionReportsIconHome className={classes.transactionReportIcon} />,
            title: "Transaction Report",
            textCss: "textV3"
        }
    ]

    const handleReportClick = (reportType) => {
        if (reportType == "truckIncome") {
            setReportOpen(true);
        } else if (reportType == "partyIncome") {
            setPartyIncomeOpen(true);
        } else if (reportType == "profitLoss") {
            setProfitLossOpen(true);
        }else if (reportType == "supplierBalance") {
            //setPdfDialogOpen(true);
            //setReportTitle("Supplier Ledger");
            setSupplierBalanceReportOpen(true)
        } else if (reportType == "partyBalance") {
            setPartyBalanceReportOpen(true);
        } else if (reportType == "transactionReport") {
            setTransactionReportOpen(true);
        }
    }

    const handleReportClose = (reportType) => {
        if (reportType == "truckIncome") {
            setReportOpen(false);
        } else if (reportType == "partyIncome") {
            setPartyIncomeOpen(false);
        } else if (reportType == "profitLoss") {
            setProfitLossOpen(false);
        }
    }

    const handleAddTripOpen = (reportType) => {
        setTimeout(() => {
            setAddTripSideBarOpen(true);
        }, 120);
        if (reportType == "truckIncome") {
            setReportOpen(false);
        } else if (reportType == "partyIncome") {
            setPartyIncomeOpen(false);
        } else if (reportType == "profitLoss") {
            setProfitLossOpen(false);
        }
    }

    const handleAddTripSideBarClose = () => {
        setAddTripSideBarOpen(false);
    }

    const handleClosePdf = () => {
        setPdfDialogOpen(false);
        setReportTitle("");
    }

    const handleClosePartyBalanceReport = () => {
        setPartyBalanceReportOpen(false);
    }
    const handleCloseSupplierBalanceReport = () => {
        setSupplierBalanceReportOpen(false);
    }

    const handleCloseTransactionReport = () => {
        setTransactionReportOpen(false);
    }

    return (
        <>
            <Grid
                container
            >
                {reportTypes.map((reportData) => (
                    <Grid item className={classes.gridItemV1}>
                        <List>
                            <ListItem button className={classes.listItemV1} onClick={() => handleReportClick(reportData.reportName)} >
                                <Card className={classes.cardV1} >
                                    <CardContent className={classes.cardContentV1} >
                                        <Grid
                                            container
                                            alignItems="center"
                                        >
                                            <Grid item>
                                                <div>
                                                    {reportData.icon}
                                                </div>
                                            </Grid>
                                            <Grid item>
                                                <div className={reportData && reportData.textCss == "textV1" ? classes.textV1 : reportData && reportData.textCss == "textV2" ? classes.textV2 : classes.textV3}>
                                                    {reportData.title}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </ListItem>
                        </List>
                    </Grid>
                ))}

            </Grid>

            {reportOpen && <TruckIncomeReport open={reportOpen} onClose={() => handleReportClose("truckIncome")} handleAddTrip={() => handleAddTripOpen("truckIncome")} />}
            {partyIncomeOpen && <PartyIncomeReport open={partyIncomeOpen} onClose={() => handleReportClose("partyIncome")} handleAddTrip={() => handleAddTripOpen("partyIncome")} />}
            {profitLossOpen && <ProfitLossReport open={profitLossOpen} onClose={() => handleReportClose("profitLoss")} handleAddTrip={() => handleAddTripOpen("profitLoss")} />}
            {pdfDialogOpen && <ReportsDialog open={pdfDialogOpen} name={reportTitle} onClose={handleClosePdf} reportType={"excelReports"} />}
            {transactionReportOpen && <TransactionReportDialog open={transactionReportOpen} name={'Transaction Report'} onClose={handleCloseTransactionReport} reportType={"excelReports"} />}
            {addTripSideBarOpen && <AddEditTripSideBar sideBarTitle="Add Trip" sideBarOpen={addTripSideBarOpen} sideBarClose={handleAddTripSideBarClose} tripId={null} />}
            {partyBalanceReportOpen && <PartyBalanceReport
                    rightSideBarOpen={partyBalanceReportOpen}
                    defaultData={null}
                    sideBarTitle={'Party Balance Report'}
                    handleSubmit={event => { }}
                    toggleRightSideBar={handleClosePartyBalanceReport}
                ><div></div></PartyBalanceReport>}
            {supplierBalanceReportOpen && <SupplierBalanceReport
                    rightSideBarOpen={supplierBalanceReportOpen}
                    defaultData={null}
                    sideBarTitle={'Supplier Balance Report'}
                    handleSubmit={event => { }}
                    toggleRightSideBar={handleCloseSupplierBalanceReport}
                ><div></div></SupplierBalanceReport>}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);